<!-- Proxmox API Explorer Section -->
<section class="proxmox-api-explorer-section" *ngIf="isLoggedIn">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="section-header mb-4">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h1 class="section-title">Proxmox API Explorer</h1>
              <p class="section-description">Browse and manage your Proxmox Virtual Environment</p>
            </div>
            <div class="d-flex gap-2">
              <button class="btn btn-outline-primary" (click)="refreshData()" [disabled]="loading">
                <i class="bx bx-refresh" [class.bx-spin]="loading"></i> Refresh
              </button>
              <button class="btn btn-outline-danger" (click)="onLogout()">
                <i class="bx bx-log-out"></i> Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Success Alert -->
    <div class="row" *ngIf="successMessage">
      <div class="col-12">
        <div class="alert alert-success alert-dismissible fade show" role="alert">
          <strong>Success:</strong> {{ successMessage }}
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
      </div>
    </div>

    <!-- Error Alert -->
    <div class="row" *ngIf="error">
      <div class="col-12">
        <div class="alert alert-danger alert-dismissible fade show" role="alert">
          <strong>Error:</strong> {{ error }}
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
      </div>
    </div>

    <!-- Loading Indicator -->
    <div class="row" *ngIf="loading">
      <div class="col-12 text-center my-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2">Loading Proxmox data...</p>
      </div>
    </div>

    <!-- Action Loading Indicator -->
    <div class="row" *ngIf="actionLoading">
      <div class="col-12 text-center my-3">
        <div class="spinner-border spinner-border-sm text-primary" role="status">
          <span class="visually-hidden">Processing...</span>
        </div>
        <span class="ms-2">Processing action...</span>
      </div>
    </div>

    <!-- Cluster Overview -->
    <div class="row" *ngIf="!loading && clusterStatus">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-header">
            <h3 class="card-title mb-0">Cluster Overview</h3>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <div class="stat-card text-center">
                  <div class="stat-icon bg-primary text-white mx-auto mb-2">
                    <i class="bx bx-server"></i>
                  </div>
                  <h3 class="stat-number">{{ vms.length }}</h3>
                  <p class="stat-label">Virtual Machines</p>
                </div>
              </div>
              <div class="col-md-3">
                <div class="stat-card text-center">
                  <div class="stat-icon bg-success text-white mx-auto mb-2">
                    <i class="bx bx-desktop"></i>
                  </div>
                  <h3 class="stat-number">{{ nodes.length }}</h3>
                  <p class="stat-label">Nodes</p>
                </div>
              </div>
              <div class="col-md-3">
                <div class="stat-card text-center">
                  <div class="stat-icon bg-info text-white mx-auto mb-2">
                    <i class="bx bx-hdd"></i>
                  </div>
                  <h3 class="stat-number">{{ storage.length }}</h3>
                  <p class="stat-label">Storage</p>
                </div>
              </div>
              <div class="col-md-3">
                <div class="stat-card text-center">
                  <div class="stat-icon bg-warning text-white mx-auto mb-2">
                    <i class="bx bx-user"></i>
                  </div>
                  <h3 class="stat-number">{{ users.length }}</h3>
                  <p class="stat-label">Users</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabs for Different Sections -->
    <div class="row" *ngIf="!loading">
      <div class="col-12">
        <ul class="nav nav-tabs" id="proxmoxTabs" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="vms-tab" data-bs-toggle="tab" data-bs-target="#vms" type="button" role="tab" aria-controls="vms" aria-selected="true">
              Virtual Machines
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="nodes-tab" data-bs-toggle="tab" data-bs-target="#nodes" type="button" role="tab" aria-controls="nodes" aria-selected="false">
              Nodes
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="storage-tab" data-bs-toggle="tab" data-bs-target="#storage" type="button" role="tab" aria-controls="storage" aria-selected="false">
              Storage
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="users-tab" data-bs-toggle="tab" data-bs-target="#users" type="button" role="tab" aria-controls="users" aria-selected="false">
              Users
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="pools-tab" data-bs-toggle="tab" data-bs-target="#pools" type="button" role="tab" aria-controls="pools" aria-selected="false">
              Pools & Access
            </button>
          </li>
        </ul>
        <div class="tab-content" id="proxmoxTabContent">
          <!-- Virtual Machines Tab -->
          <div class="tab-pane fade show active" id="vms" role="tabpanel" aria-labelledby="vms-tab">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title mb-0">Virtual Machines</h3>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Node</th>
                        <th>Type</th>
                        <th>Status</th>
                        <th>CPU</th>
                        <th>Memory</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let vm of vms">
                        <td>{{ vm.vmid }}</td>
                        <td>{{ vm.name }}</td>
                        <td>{{ vm.node }}</td>
                        <td>{{ vm.type }}</td>
                        <td>
                          <span class="badge" [ngClass]="getVMStatusClass(vm.status)">{{ vm.status }}</span>
                        </td>
                        <td>{{ vm.cpu !== undefined ? (vm.cpu * 100).toFixed(1) + '%' : 'N/A' }}</td>
                        <td>{{ vm.mem !== undefined ? formatBytes(vm.mem) : 'N/A' }}</td>
                        <td>
                          <div class="btn-group" role="group">
                            <button class="btn btn-sm btn-success" title="Start" (click)="startVM(vm.node, vm.type, vm.vmid, vm.name)" [disabled]="actionLoading || vm.status === 'running'">
                              <i class="bx bx-play"></i>
                            </button>
                            <button class="btn btn-sm btn-warning" title="Restart" (click)="resetVM(vm.node, vm.type, vm.vmid, vm.name)" [disabled]="actionLoading">
                              <i class="bx bx-reset"></i>
                            </button>
                            <button class="btn btn-sm btn-danger" title="Stop" (click)="stopVM(vm.node, vm.type, vm.vmid, vm.name)" [disabled]="actionLoading || vm.status === 'stopped'">
                              <i class="bx bx-stop"></i>
                            </button>
                            <button class="btn btn-sm btn-info" title="Shutdown" (click)="shutdownVM(vm.node, vm.type, vm.vmid, vm.name)" [disabled]="actionLoading || vm.status === 'stopped'">
                              <i class="bx bx-power-off"></i>
                            </button>
                            <button class="btn btn-sm btn-secondary" title="Suspend" (click)="suspendVM(vm.node, vm.type, vm.vmid, vm.name)" [disabled]="actionLoading || vm.status !== 'running'">
                              <i class="bx bx-pause"></i>
                            </button>
                            <button class="btn btn-sm btn-primary" title="Resume" (click)="resumeVM(vm.node, vm.type, vm.vmid, vm.name)" [disabled]="actionLoading || vm.status !== 'paused'">
                              <i class="bx bx-play-circle"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <!-- Nodes Tab -->
          <div class="tab-pane fade" id="nodes" role="tabpanel" aria-labelledby="nodes-tab">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title mb-0">Nodes</h3>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Online</th>
                        <th>CPU Usage</th>
                        <th>Memory Usage</th>
                        <th>Uptime</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let node of nodes">
                        <td>{{ node.node }}</td>
                        <td>
                          <span class="badge" [ngClass]="node.online ? 'bg-success' : 'bg-danger'">
                            {{ node.online ? 'Online' : 'Offline' }}
                          </span>
                        </td>
                        <td>{{ node.cpu !== undefined ? (node.cpu * 100).toFixed(1) + '%' : 'N/A' }}</td>
                        <td>
                          {{ node.mem !== undefined && node.maxmem !== undefined ? 
                             ((node.mem / node.maxmem) * 100).toFixed(1) + '%' : 'N/A' }}
                        </td>
                        <td>{{ node.uptime !== undefined ? formatUptime(node.uptime) : 'N/A' }}</td>
                        <td>
                          <div class="btn-group" role="group">
                            <button class="btn btn-sm btn-success" title="View Services" (click)="viewNodeServices(node.node)">
                              <i class="bx bx-detail"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                
                <!-- Node Services Section (Hidden by default) -->
                <div id="node-services-section" class="mt-4" style="display: none;">
                  <h4>Node Services</h4>
                  <div class="table-responsive">
                    <table class="table table-striped table-hover">
                      <thead>
                        <tr>
                          <th>Service</th>
                          <th>Description</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody id="node-services-body">
                        <!-- Services will be populated here dynamically -->
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Storage Tab -->
          <div class="tab-pane fade" id="storage" role="tabpanel" aria-labelledby="storage-tab">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title mb-0">Storage</h3>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th>Storage</th>
                        <th>Type</th>
                        <th>Content</th>
                        <th>Usage</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let store of storage">
                        <td>{{ store.storage }}</td>
                        <td>{{ store.type }}</td>
                        <td>{{ store.content }}</td>
                        <td>
                          {{ store.used !== undefined && store.total !== undefined ? 
                             ((store.used / store.total) * 100).toFixed(1) + '%' : 'N/A' }}
                        </td>
                        <td>
                          <span class="badge" [ngClass]="store.active ? 'bg-success' : 'bg-danger'">
                            {{ store.active ? 'Active' : 'Inactive' }}
                          </span>
                        </td>
                        <td>
                          <div class="btn-group" role="group">
                            <button class="btn btn-sm btn-primary" title="View Content" (click)="viewStorageContent(store.storage, store.storage)">
                              <i class="bx bx-detail"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <!-- Users Tab -->
          <div class="tab-pane fade" id="users" role="tabpanel" aria-labelledby="users-tab">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title mb-0">Users</h3>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th>User</th>
                        <th>Enabled</th>
                        <th>Expiration</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let user of users">
                        <td>{{ user.userid }}</td>
                        <td>
                          <span class="badge" [ngClass]="user.enabled ? 'bg-success' : 'bg-danger'">
                            {{ user.enabled ? 'Enabled' : 'Disabled' }}
                          </span>
                        </td>
                        <td>{{ user.expire !== undefined ? (user.expire === 0 ? 'Never' : user.expire) : 'N/A' }}</td>
                        <td>{{ user.firstname || 'N/A' }}</td>
                        <td>{{ user.lastname || 'N/A' }}</td>
                        <td>{{ user.email || 'N/A' }}</td>
                        <td>
                          <div class="btn-group" role="group">
                            <button class="btn btn-sm btn-primary" title="View Details" (click)="viewUserDetails(user.userid, user.userid)">
                              <i class="bx bx-detail"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <!-- Pools & Access Tab -->
          <div class="tab-pane fade" id="pools" role="tabpanel" aria-labelledby="pools-tab">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title mb-0">Pools & Access Control</h3>
              </div>
              <div class="card-body">
                <ul class="nav nav-tabs" id="accessControlTabs" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button class="nav-link active" id="pools-content-tab" data-bs-toggle="tab" data-bs-target="#pools-content" type="button" role="tab" aria-controls="pools-content" aria-selected="true">
                      Pools
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button class="nav-link" id="groups-tab" data-bs-toggle="tab" data-bs-target="#groups" type="button" role="tab" aria-controls="groups" aria-selected="false">
                      Groups
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button class="nav-link" id="roles-tab" data-bs-toggle="tab" data-bs-target="#roles" type="button" role="tab" aria-controls="roles" aria-selected="false">
                      Roles
                    </button>
                  </li>
                </ul>
                <div class="tab-content" id="accessControlTabContent">
                  <!-- Pools Content -->
                  <div class="tab-pane fade show active" id="pools-content" role="tabpanel" aria-labelledby="pools-content-tab">
                    <div class="table-responsive mt-3">
                      <table class="table table-striped table-hover">
                        <thead>
                          <tr>
                            <th>Pool</th>
                            <th>Comment</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let pool of pools">
                            <td>{{ pool.poolid }}</td>
                            <td>{{ pool.comment || 'N/A' }}</td>
                            <td>
                              <div class="btn-group" role="group">
                                <button class="btn btn-sm btn-primary" title="View Details">
                                  <i class="bx bx-detail"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  
                  <!-- Groups Content -->
                  <div class="tab-pane fade" id="groups" role="tabpanel" aria-labelledby="groups-tab">
                    <div class="table-responsive mt-3">
                      <table class="table table-striped table-hover">
                        <thead>
                          <tr>
                            <th>Group</th>
                            <th>Comment</th>
                            <th>Users</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>admin</td>
                            <td>Administrators</td>
                            <td>2</td>
                            <td>
                              <div class="btn-group" role="group">
                                <button class="btn btn-sm btn-primary" title="View Details" (click)="viewGroupDetails('admin', 'admin')">
                                  <i class="bx bx-detail"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>users</td>
                            <td>Regular Users</td>
                            <td>5</td>
                            <td>
                              <div class="btn-group" role="group">
                                <button class="btn btn-sm btn-primary" title="View Details" (click)="viewGroupDetails('users', 'users')">
                                  <i class="bx bx-detail"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  
                  <!-- Roles Content -->
                  <div class="tab-pane fade" id="roles" role="tabpanel" aria-labelledby="roles-tab">
                    <div class="table-responsive mt-3">
                      <table class="table table-striped table-hover">
                        <thead>
                          <tr>
                            <th>Role</th>
                            <th>Privileges</th>
                            <th>Special</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>PVEAdmin</td>
                            <td>Full access</td>
                            <td>Yes</td>
                            <td>
                              <div class="btn-group" role="group">
                                <button class="btn btn-sm btn-primary" title="View Details" (click)="viewRoleDetails('PVEAdmin', 'PVEAdmin')">
                                  <i class="bx bx-detail"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>PVEUser</td>
                            <td>Limited access</td>
                            <td>No</td>
                            <td>
                              <div class="btn-group" role="group">
                                <button class="btn btn-sm btn-primary" title="View Details" (click)="viewRoleDetails('PVEUser', 'PVEUser')">
                                  <i class="bx bx-detail"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Login Redirect -->
<div *ngIf="!isLoggedIn" class="container">
  <div class="row">
    <div class="col-12 text-center my-5">
      <h2>Redirecting to login...</h2>
      <p>Please wait while we redirect you to the login page.</p>
    </div>
  </div>
</div>